/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../Pagination/Pagination'
import $ from 'jquery'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SearchableCombo from '../BaseComponent/searchableCombo'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import TMS from '../BaseComponent/TMS'
import {MDBCol} from './CreateTask'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import Loader from '../loaders/loader'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'
class ReportDuplicated extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      buttonClicked: false,
      printInfo: [],
      lengthProviders: 0,
      planDateMin: '',
      planDateMax: '',
      list: [],
      providers: [],
      products: [],
      providerId: '',
      productId: '',
      tasks: [],
      sections: [],
      modalReject: false,
      modalAccept: false,
      fromDate: '',
      toDate: '',
      operators: [],
      personId: '',
      department: [],
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: 'activityDate_desc',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کاربر',
          value: 'user.name',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'دپارتمان',
          value: 'departmentTitle',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'بخش',
          value: 'sectionTitle',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'فعالیت',
          value: 'taskTitle',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تامین کننده',
          value: 'providerTitle',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'کالا',
          value: 'productTitle',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'بازه زمانی',
          value: 'taskTimeMinuteMin',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'وضعیت',
          value: 'state',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ ثبت',
          value: 'creationTime',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد',
          value: 'count',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ فعالیت',
          value: 'activityDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان تخمینی',
          value: 'timeMinuteUser',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'توضیحات',
          value: 'description',
          sorted: false,
          direction: null,
          sortable: true
        },
        // {
        //     name: "تعداد",
        //     value: "activityCount",
        //     sorted: false,
        //     direction: null,
        //     sortable: true
        // },
        // {
        //     name: "نیاز به تامین کننده",
        //     value: "needProvider",
        //     sorted: false,
        //     direction: null,
        //     sortable: true
        // },
        // {
        //     name: "نیاز به محصول",
        //     value: "needProduct",
        //     sorted: false,
        //     direction: null,
        //     sortable: true
        // },
        {
          name: 'نمایش جزییات',
          value: 'count',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  changeOrg(e) {
    let value = e.target.value
    if (value === '') {
      this.setState({
        sections: []
      })
    } else {
      let personId = localStorage.getItem('personId')

      http
        .get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?departmentId=${value}&personId=${personId}`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              sections: response.data.object
            })
          } else {
            this.setState({
              sections: []
            })
          }
        })
    }
  }

  getValueProvider = (providerId) => {
    if (providerId === null) {
      this.setState({
        products: [],
        providerId: null
      })
    } else {
      this.setState({
        providerId
      })
      let id = providerId

      http
        .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PRODUCT}`, {
          params: {
            providerId: id,
            sortByTitle: true
          }
        })
        .then((response) => {
          if (response.data.error === null) {
            var products = response.data.object
            for (let i = 0; i < products.length; i++) {
              products[i]['value'] = products[i].productId
              products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
            }
            this.setState({
              products: response.data.object
            })
          } else {
            this.setState({
              products: []
            })
          }
        })
    }
  }

  getValueProduct = (productId) => {
    if (productId === null) {
      this.setState({
        productId: ''
      })
    } else {
      this.setState({
        productId
      })
    }
  }

  getValueOperator = (personId) => {
    if (personId === null) {
      this.setState({
        personId: ''
      })
    } else {
      this.setState({
        personId
      })
    }
  }

  changeSec(e) {
    let value = e.target.value
    if (value === '') {
      this.setState({
        tasks: []
      })
    } else {
      http.get(`${TMS.TMS_MANAGE_BASE_TASK_LIST}?sectionId=${value}`, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            tasks: response.data.object
          })
        } else {
          this.setState({
            tasks: []
          })
        }
      })
    }
  }

  componentDidMount() {
    let personId = localStorage.getItem('personId')

    http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}?personId=${personId}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      }
    })

    if (this.props.match.params.activityId != undefined) {
      this.fetchHistory(this.props.match.params.activityId || '')
    }

    http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })

    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`,{
    //     params: {
    //         sortByTitle: true,
    //         all: true

    //     }
    // }).then((response)=>{
    //     if(response.data.error==null){

    //         var provider = response.data.object;
    //         for (let i = 0; i < provider.length; i++) {
    //             provider[i]['value'] = provider[i].providerId;
    //             provider[i]['label'] =provider[i].providerId +' - '+ provider[i].title;
    //         }

    //         this.setState({
    //             providers:response.data.object
    //         })
    //     }
    //     else{
    //         this.setState({
    //             providers:[]
    //         })
    //     }
    // })

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.basketFilterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  convertCount = (count) => {
    if (count !== null) {
      return count.toFixed(1).replace('.0', '')
    } else {
      return ''
    }
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${TMS.TMS_MANAGE_ACTIVITY_DUPLICATE}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()

          if (!exportStatus) {
            this.setState({
              list: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false,
              buttonClicked: true
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          }
        } else {
          $('.showBaseTable,.print').fadeOut()

          this.setState({
            list: [],
            countAll: 0,
            loading: false
          })
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let sectionId = document.getElementById('sectionId').value
    let taskId = document.getElementById('taskId').value
    let departmentId = document.getElementById('departmentId').value
    let needProvider = document.getElementById('needProvider').value
    let needProduct = document.getElementById('needProduct').value
    // let description = document.getElementById('description').value.trim();

    // let state = document.getElementById('state').value;
    // let activityDeleted = document.getElementById('activityDeleted').value;
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate
    let personId = this.state.personId !== '' ? this.state.personId.personId : ''
    let providerId = this.state.providerId
    let productId = this.state.productId === '' || this.state.productId === null ? '' : this.state.productId.productId
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (sectionId !== '') {
      filter.sectionId = sectionId
    }
    if (taskId !== '') {
      filter.taskId = taskId
    }
    if (departmentId !== '') {
      filter.departmentId = departmentId
    }
    if (needProvider !== '') {
      filter.needProvider = needProvider
    }
    if (needProduct !== '') {
      filter.needProduct = needProduct
    }
    // if ( state !== "" && state.length) {
    //     filter.state = state;
    // }
    // if (activityDeleted !== "") {
    //     filter.activityDeleted = activityDeleted;
    // }
    if (activityDateMin !== '') {
      filter.activityDateMin = activityDateMin
    }
    if (activityDateMax !== '') {
      filter.activityDateMax = activityDateMax
    }
    if (personId !== '') {
      filter.personId = personId
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }
    if (productId !== '') {
      filter.productId = productId
    }
    // if (description !== "") {
    //     filter.description = description;
    // }
    return filter
  }

  filter() {
    // let activityDeleted = document.getElementById('activityDeleted').value.trim();
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate

    if (activityDateMin === '' || activityDateMax === '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((activityDateMin !== '' || activityDateMin === null) && isNaN(activityDateMin)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((activityDateMax !== '' || activityDateMax === null) && isNaN(activityDateMax)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      // this.setState({
      //     toPrintDate:this.state.fromDate === ''? '-' :jMoment(this.state.fromDate).format('jYY/jMM/jDD')
      //     ,
      //     fromPrintDate:this.state.toDate === ''? '-' :jMoment(this.state.toDate).format('jYY/jMM/jDD')
      //
      // })
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${TMS.TMS_MANAGE_ACTIVITY_DUPLICATE}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result,
            countAll: response.data.object.countAll
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['time'] = jMoment(excelReport[i]['time']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['creationTime'] = jMoment(excelReport[i]['creationTime']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['activityDate'] = jMoment(excelReport[i]['activityDate']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['state'] = this.convertStateExcel(excelReport[i]['state'])
            excelReport[i].timeMinuteOperator = this.convertCount(excelReport[i].timeMinuteOperator)
            excelReport[i].timeMinuteUser = this.convertCount(excelReport[i].timeMinuteUser)
            excelReport[i].count = this.convertCount(excelReport[i].count)
            if (excelReport[i]['activityDeleted']) {
              excelReport[i]['activityDeleted'] = 'حذف شده'
            } else {
              excelReport[i]['activityDeleted'] = 'حذف نشده'
            }

            excelReport[i]['needProvider'] = this.convertStateForceOptional(excelReport[i]['needProvider'])
            excelReport[i]['needProduct'] = this.convertStateForceOptional(excelReport[i]['needProduct'])
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  onResultFetched(data) {
    this.setState({
      list: data
    })
  }

  changeDropDown(data) {
    this.setState({
      list: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  convertState = (state) => {
    switch (state) {
      case 100:
        return 'در انتظار'
        break
      case 10:
        return <img src={require('../../image/confirm.svg')} style={{width: '20px'}} />
        break
      case 20:
        return <img src={require('../../image/ignor.svg')} style={{width: '20px'}} />
        break
      default:
        return '-'
    }
  }

  convertStateExcel = (state) => {
    switch (state) {
      case 100:
        return 'در انتظار'
        break
      case 10:
        return 'تایید شده'
        break
      case 20:
        return 'تایید نشده'
        break
      default:
        return '-'
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  sendQueryProvider = (needProvider, providerId) => {
    return providerId
    // if(needProvider){
    //     return providerId
    // }
    // else {
    //     return ''
    // }
  }
  sendQueryProduct = (needProduct, productId) => {
    return productId
    // if(needProduct){
    //     return productId
    // }
    // else {
    //     return ''
    // }
  }

  convertStateForceOptional = (state) => {
    if (state === 1) {
      return 'اجباری'
    } else if (state === 0) {
      return 'اختیاری'
    } else if (state === -1) {
      return 'عدم انتخاب'
    }
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'کاربر',
      'دپارتمان',
      'بخش',
      'فعالیت',
      'تامین کننده',
      'کالا',
      'بازه زمانی',
      'وضعیت',
      'تاریخ ثبت',
      'تعداد',
      'تاریخ فعالیت',
      'زمان تخمینی',
      'توضیحات'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش فعالیت های تکراری"
              headerColSpan={14}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={6}
              rightColSpan={6}
              centerColSpan={2}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.user !== null && item.user.name}</td>
                  <td>{item.departmentTitle}</td>
                  <td>{item.sectionTitle}</td>
                  <td>{item.taskTitle}</td>
                  <td>{item.providerTitle}</td>
                  <td>{item.productTitle}</td>
                  <td>{item.taskTimeMinuteMin + ' - ' + item.taskTimeMinuteMax + ' دقیقه '}</td>

                  <td>{this.convertState(item.state)}</td>
                  <td>{jMoment(item.creationTime).format('jYYYY/jMM/jDD')}</td>
                  <td>{this.convertCount(item.count)}</td>
                  <td>{jMoment(item.activityDate).format('jYYYY/jMM/jDD')}</td>
                  <td>{this.convertCount(item.timeMinuteUser) + ' دقیقه '}</td>
                  <td>{item.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش فعالیت های تکراری.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              {/*<gridColumn key={'time'} field={'time'} title={'تاریخ آخرین تغییر'} width="150px"*/}
              {/*            footerCellOptions={{wrap: true, textAlign: 'center'}}/>*/}
              {/*<gridColumn key={'name'} field={'user.name'} title={'کاربر'} width="150px"*/}
              {/*            footerCellOptions={{wrap: true, textAlign: 'center'}}/>*/}

              <gridColumn
                key={'name'}
                field={'user.name'}
                title={'کاربر'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'departmentTitle'}
                field={'departmentTitle'}
                title={'دپارتمان'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sectionTitle'}
                field={'sectionTitle'}
                title={'بخش'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'taskTitle'}
                field={'taskTitle'}
                title={'فعالیت'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerTitle'}
                field={'providerTitle'}
                title={'تامین کننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productTitle'}
                field={'productTitle'}
                title={'کالا'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'taskTimeMinuteMin'}
                field={'taskTimeMinuteMin'}
                title={'بازه زمانی از '}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'taskTimeMinuteMax'}
                field={'taskTimeMinuteMax'}
                title={'بازه زمانی تا '}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'state'}
                field={'state'}
                title={'وضعیت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'creationTime'}
                field={'creationTime'}
                title={'تاریخ ثبت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'count'}
                field={'count'}
                title={'تعداد'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'activityDate'}
                field={'activityDate'}
                title={'تاریخ فعالیت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteUser'}
                field={'timeMinuteUser'}
                title={'زمان تخمینی'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'description'}
                field={'description'}
                title={'توضیحات'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>مدیریت فعالیت ها</li>
            <li>فعالیت های تکراری</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel=" تاریخ فعالیت از"
                  toLabel=" تاریخ فعالیت تا"
                  defaulValue={true}
                  force
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.getValueOperator}
                    lableText="کاربران"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    دپارتمان
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeOrg.bind(this)}
                    name="departmentId"
                    id="departmentId"
                  >
                    <option value="">------</option>
                    {this.state.department.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    بخش
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeSec.bind(this)}
                    name="sectionId"
                    id="sectionId"
                  >
                    <option value="">------</option>
                    {this.state.sections.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    فعالیت
                  </label>
                  <select className="custom-select" name="taskId" id="taskId">
                    <option value="">------</option>
                    {this.state.tasks.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={this.getValueProvider}
                  />
                  {/* <SearchableCombo
                                        options={this.state.providers}
                                        getValueCombo={this.getValueProvider}
                                        lableText='تامین کننده'
                                        placeholder='------'
                                        isClearable={true}
                                        isMulti={false}
                                        className='font-weight-bold'

                                    /> */}
                </div>
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.products}
                    getValueCombo={this.getValueProduct}
                    lableText="کالا"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>
                <div className="formComponent">
                  <label className="font-weight-bold">نیاز به تامین کننده</label>
                  <select className="custom-select" name="needProvider" id="needProvider">
                    <option value="">------</option>
                    <option value={0}>اختیاری</option>
                    <option value={1}>اجباری</option>
                    <option value={-1}>عدم انتخاب</option>
                  </select>
                </div>
                <div className="formComponent">
                  <label className="font-weight-bold">نیاز به محصول</label>
                  <select className="custom-select" name="needProduct" id="needProduct">
                    <option value="">------</option>
                    <option value={0}>اختیاری</option>
                    <option value={1}>اجباری</option>
                    <option value={-1}>عدم انتخاب</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                <tbody>
                  {this.state.list.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.user !== null && item.user.name}</td>
                      <td>{item.departmentTitle}</td>
                      <td>{item.sectionTitle}</td>
                      <td style={{width: '300px'}}>{item.taskTitle}</td>
                      <td style={{width: '200px'}}>{item.providerTitle}</td>
                      <td style={{width: '200px'}}>
                        <a target="_blank" href={productShop({articleId: item.articleId})}>
                          {item.productTitle}
                        </a>
                      </td>
                      <td>{item.taskTimeMinuteMin + ' - ' + item.taskTimeMinuteMax + ' دقیقه '}</td>

                      <td>{this.convertState(item.state)}</td>
                      <td>{jMoment(item.creationTime).format('jYYYY/jMM/jDD')}</td>
                      <td>{this.convertCount(item.count)}</td>
                      <td>{jMoment(item.activityDate).format('jYYYY/jMM/jDD')}</td>
                      <td>{this.convertCount(item.timeMinuteUser) + ' دقیقه '}</td>
                      <td style={{width: '200px'}}>{item.description}</td>
                      {/*<td>{item.activityCount}</td>*/}
                      {/*<td>{this.convertStateForceOptional(item.needProvider)}</td>*/}
                      {/*<td>{this.convertStateForceOptional(item.needProduct)}</td>*/}
                      <td>
                        <Link
                          target="_blank"
                          to={`/tms/manageTask/report?departmentId=${item.departmentId}&sectionId=${
                            item.sectionId
                          }&taskId=${item.taskId}&providerId=${this.sendQueryProvider(
                            item.needProvider,
                            item.providerId
                          )}&productId=${this.sendQueryProduct(item.needProduct, item.productId)}`}
                        >
                          <img src={require('../../image/details.svg')} title="جزییات فعالیت" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ReportDuplicated
